// extracted by mini-css-extract-plugin
export default {"img":"styles_img__Myc2o","placeholder":"styles_placeholder__1aKck"};